import React from 'react';
import map from 'mn-utils/map';

module.exports = ({items}) => {
  return (
    <div className="layoutRow fxwWrap mt22 bgFAFAFA r9 bxsh4c00000040">
      {map(items, (item, i) => (
        <div
          key={i}
          className={
            `fx1 pt14 ph21 pb18 bxzBorderBox bl2 bslSolid bclT bclE8E8E8:not[:first-child]
            w@m2 pt24@m bl0@m2 bt1@m2 bstSolid@m2 bctT@m2 bctE8E8E8:not[:first-child]@m2`
          }
        >
          <span className="d fwB f16 lh24">{item.name}</span>
          <span className="d mt4 fw5 f12 lh18">{item.value}</span>
        </div>
      ))}
    </div>
  );
};
